// frontend/contexts/SidebarContext.tsx

import { createContext, useContext } from "react";

export type DropWhere = "before" | "after" | "inside";

export interface DropTarget {
  id: string;
  where: DropWhere;
}

// 사이드바 전역 상태 및 이벤트 핸들러 타입 정의
interface SidebarContextType {
  docs: any[];
  user: any;
  expandedDocs: Record<string, boolean>;
  setExpandedDocs: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  dropTarget: DropTarget | null;
  handleDragStart: (e: React.DragEvent, docId: string) => void;
  handleDragOver: (e: React.DragEvent, targetId: string | null, where?: DropWhere) => void;
  handleDragLeave: (e: React.DragEvent) => void;
  handleDrop: (e: React.DragEvent, targetParentId: string | null, targetWorkspaceType: string) => void;
  handleReorder: (e: React.DragEvent, targetId: string, where: "before" | "after") => void;
  handleContextMenu: (
    e: React.MouseEvent,
    docId: string,
    title: string,
    icon: string | null,
    isTrueOwner: boolean,
    section?: "recent" | "favorite" | "team" | "personal",
    isFavorite?: boolean,
    isRoot?: boolean,
    updatedBy?: string,
    updatedAt?: string,
    permLevel?: "FULL" | "EDIT" | "COMMENT" | "READ" | null
  ) => void;
  openCreateModal: (type: "TEAM" | "PERSONAL", parentId: string | null, parentTitle: string) => void;
  colorTheme: string;
}

export const SidebarContext = createContext<SidebarContextType | null>(null);

// 컨텍스트 접근 전용 커스텀 훅
export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) throw new Error("SidebarContext는 Provider 내부에서 사용되어야 합니다.");
  return context;
};
